// extracted by mini-css-extract-plugin
export default {"checkboxWrap":"CrystalReportOptionsConf_checkboxWrap__4r1Fs","settingsButton":"CrystalReportOptionsConf_settingsButton__6BH2w","checkbox":"CrystalReportOptionsConf_checkbox__5AuuO"};